import React, { lazy, Suspense, useEffect, useRef, useState } from "react";

// Components
import Banner from "../components/Banner";
import Categorypills from "../components/Categorypills";
const Latestupdates = lazy(() => import("../components/Latestupdates"));
const Honeymoonindia = lazy(() => import("../components/Honeymoonindia"));
const Internationalbymonth = lazy(() => import("../components/Internationalbymonth"));
const Experienceindiabymonth = lazy(() => import("../components/Experienceindiabymonth"));
const VisaProcess = lazy(() => import("../components/Visaprocess"));
const BrandStory = lazy(() => import("../components/BrandStory"));
const UniqueStays = lazy(() => import("../components/UniqueStays"));
const Aroundtheworld = lazy(() => import("../components/Aroundtheworld"));
const VisaFreeEscapes = lazy(() => import("../components/Visafreeescapes"));
const HoneymoonGlobal = lazy(() => import("../components/HoneymoonGlobal"));
const TravelMood = lazy(() => import("../components/Travelmood"));
const AdShortcode = lazy(() => import("../components/AdShortcode"));

const SectionFallback = () => <div className="mx-auto w-full max-w-[1500px] min-h-[80px]" aria-hidden="true" />;

function RenderOnView({ children, fallback = <SectionFallback />, rootMargin = "1200px 0px" }) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) return;
    const el = ref.current;
    if (!el) return;

    if (typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { root: null, rootMargin, threshold: 0.01 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [isVisible, rootMargin]);

  return <div ref={ref}>{isVisible ? children : fallback}</div>;
}

function Home({ darkMode = false }) {
  return (
    <div className="w-full overflow-x-hidden">

      {/* Wrapper for spacing */}
      <div className="space-y-12 min-w-0 px-0 lg:px-[25px]">
        {/* Banner Section */}
        <Banner darkMode={darkMode} />

        {/* All sections except Banner */}
        <div className="space-y-12 max-md:[&_h2]:text-[21px] max-md:[&_h3]:text-[24px] max-md:[&_p]:text-[18px]">
          {/* Category Pills */}
          <Categorypills darkMode={darkMode} />

          {/* Latest Updates */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <Latestupdates darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <div className="mx-auto w-full max-w-[1500px]">
                <AdShortcode shortcode="[trw_ad_slider]" />
              </div>
            </Suspense>
          </RenderOnView>

          {/* Honeymoon Global */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <HoneymoonGlobal darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          {/* Experience India by Month */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <Experienceindiabymonth darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <div className="mx-auto w-full max-w-[1500px]">
                <AdShortcode shortcode="[trw_ad_slider]" />
              </div>
            </Suspense>
          </RenderOnView>

          {/* Honeymoon India */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <Honeymoonindia darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          {/* International by Month */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <Internationalbymonth darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <div className="mx-auto w-full max-w-[1500px]">
                <AdShortcode shortcode="[trw_ad_slider]" />
              </div>
            </Suspense>
          </RenderOnView>

          {/* Brand Story */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <BrandStory darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          {/* Visa Process */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <VisaProcess darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <div className="mx-auto w-full max-w-[1500px]">
                <AdShortcode shortcode="[trw_ad_slider]" />
              </div>
            </Suspense>
          </RenderOnView>

          {/* Unique Stay */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <UniqueStays darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          {/* Around the World */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <Aroundtheworld darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <div className="mx-auto w-full max-w-[1500px]">
                <AdShortcode shortcode="[trw_ad_slider]" />
              </div>
            </Suspense>
          </RenderOnView>

          {/* Visa Free Escapes */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <VisaFreeEscapes darkMode={darkMode} />
            </Suspense>
          </RenderOnView>

          {/* Travel Mood */}
          <RenderOnView>
            <Suspense fallback={<SectionFallback />}>
              <TravelMood darkMode={darkMode} />
            </Suspense>
          </RenderOnView>
        </div>
      </div>

    </div>
  );
}

export default Home;
